module.exports = __webpack_public_path__ + "img/40_42.55b288a7.png";